import { styled } from 'styled-components';

import { Card, Typography } from '@mui/material';

export const MainCardWrapper = styled(Card)`
  box-shadow: none;
  border-radius: 0;
  min-height: 400px;
  padding: 2.5em;
  text-align: start;
`;

export const Title = styled(Typography)`
  margin-bottom: 2rem;
`;
